import {Category} from '../../types';
import {getParents} from './getParents';
import {formatHeirachicalName} from './formatHeirachicalName';

export function getHeirachicalName(category : Category, categories : Category[]): string {
    const parents = getParents(category, categories);
    const name = formatHeirachicalName(category.name, parents.map(p => p.name));

    return name;
}